import React from 'react';
import PropTypes from 'prop-types';

import ColumnedSection from '../right-pane/columned-section';
import DomainDetailsNotesContainer from './domain-details-notes-container';
import ExpansionComponent from '../right-pane/expansion-component';
import { rateFormatter } from '../table/table-utils';
import { formatNumber } from '../utils/common-utils';
import { translate } from '../utils/translation-utils';

const DomainDetailsTabGeneral = ( { domainData, domainNotesData } ) => {
    const { orgDomain, domainType, dmarcPolicy,
        percentBlocked, dmarcPassRate, dmarcDoublePassRate,
        spfPassRate, spfAlignRate, spfPassAlignRate,
        dkimPassRate, dkimAlignRate, dkimPassAlignRate,
        authorizedMailVolume, unauthorizedBlockRate, unauthorizedMailVolume, unauthorizedDMARCPassRate } = domainData;

    const domainHeadings = [
        { automationId: 'dd-domain-type', title: 'Domain Type', value: translate( domainType ) },
        {  automationId: 'dd-dmarc-policy', title: 'DMARC Policy', value: translate( dmarcPolicy ) },
        {  automationId: 'dd-domain-group', title: 'Domain Group', value: orgDomain },
    ];

    const AuthorizedMessages = {
        data: [
            { automationId: 'dd-auth-volume', title: 'Message Volume', value: formatNumber( authorizedMailVolume ) },
            { automationId: 'dd-auth-dmarc-pass', title: 'DMARC Pass Rate', value: rateFormatter( dmarcPassRate ) },
            { automationId: 'dd-auth-dmarc-doube-pass', title: 'DMARC Double Pass Rate', value: rateFormatter( dmarcDoublePassRate ) },
            { automationId: 'dd-auth-spf-pass', title: 'SPF Pass Rate', value: rateFormatter( spfPassRate ) },
            { automationId: 'dd-auth-spf-align', title: 'SPF Alignment Rate', value: rateFormatter( spfAlignRate ) },
            { automationId: 'dd-auth-spf-pass-align', title: '(SPF) DMARC Pass Rate', value: rateFormatter( spfPassAlignRate ) },
            { automationId: 'dd-auth-dkim-pass-rate', title: 'DKIM Pass Rate', value: rateFormatter( dkimPassRate ) },
            { automationId: 'dd-auth-dkim-align', title: 'DKIM Alignment Rate', value: rateFormatter( dkimAlignRate ) },
            { automationId: 'dd-auth-dkim-pass-align', title: '(DKIM) DMARC Pass Rate', value: rateFormatter( dkimPassAlignRate ) },
            { automationId: 'dd-auth-blocked', title: 'Block Rate', value: rateFormatter( percentBlocked ) },
        ],
        title: 'Messages (by permitted senders)',
    };

    const UnauthorizedMessages = {
        data: [
            { automationId: 'dd-unauth-volume', title: 'Message Volume', value: formatNumber( unauthorizedMailVolume ) },
            { automationId: 'dd-unauth-dmarc-pass', title: 'DMARC Pass Rate', value: rateFormatter( unauthorizedDMARCPassRate ) },
            { automationId: 'dd-unauth-blocked', title: 'Block Rate', value: rateFormatter( unauthorizedBlockRate ) },
        ],
        title: 'Messages (by not permitted & undetermined senders)',
    };

    return (
        <>
            <ColumnedSection data={domainHeadings} gutterTop={false} />
            <ExpansionComponent
                title={AuthorizedMessages.title}
                dataAutomationId="dd-authorized-messages-section"
                expanded>
                <ColumnedSection data={AuthorizedMessages.data} expandable={true} />
            </ExpansionComponent>
            <ExpansionComponent
                title={UnauthorizedMessages.title}
                dataAutomationId="dd-unauthorized-messages-section"
                expanded>
                <ColumnedSection data={UnauthorizedMessages.data} expandable={true} />
            </ExpansionComponent>
            <ExpansionComponent title="Notes" dataAutomationId="dd-notes-section">
                <DomainDetailsNotesContainer domainNotesData={domainNotesData} />
            </ExpansionComponent>
        </>
    );
};

DomainDetailsTabGeneral.propTypes = {
    domainData: PropTypes.shape( {
        actionsCount: PropTypes.number,
        authorizedMailVolume: PropTypes.number,
        dkimAlignRate: PropTypes.string,
        dkimPassAlignRate: PropTypes.string,
        dkimPassRate: PropTypes.string,
        dmarcDoublePassRate: PropTypes.string,
        dmarcPassRate: PropTypes.string,
        dmarcPolicy: PropTypes.string,
        domainCount: PropTypes.number,
        domainName: PropTypes.string,
        domainType: PropTypes.string,
        orgDomain: PropTypes.string,
        percentBlocked: PropTypes.string,
        spfAlignRate: PropTypes.string,
        spfPassAlignRate: PropTypes.string,
        spfPassRate: PropTypes.string,
    } ),
    domainNotesData: PropTypes.array,
};

export default DomainDetailsTabGeneral;
